<template>
    <div>
        <headline>
            Anwesenheit <span class="text-gray-500" v-if="datesText.length > 0">{{ datesText[0] }} - {{ datesText.slice(-1)[0] }}</span>
            <template slot="more">
                <button-secondary @click="load(prev)" class="mr-2"><template slot="icon"><i class="fa fa-calendar-minus-o"></i></template> Vorherige Woche</button-secondary>
                <button-secondary @click="load(next)"><template slot="icon"><i class="fa fa-calendar-plus-o"></i></template> Nächste Woche</button-secondary>
            </template>
        </headline>

        <loading v-show="loading"></loading>

        <tailwind-table :header="header" class="mb-4" :has_filter=true>
            <template slot="search">
                <input-text v-model="search" class="w-full">
                    Suche
                </input-text>
            </template>
            <template slot="filter">
                <user-group-filter v-model="userGroupFilter">
                    Gruppe
                </user-group-filter>
            </template>
            <tr v-for="(item, i) in usersSorted" :class="{'bg-gray-50': i % 2}">
                <td class="px-6 py-3">{{ item.first_name }} {{ item.name }}</td>
                <td class="px-6 py-3">
                    {{ item.user_groups.map(g => g.name).join(', ') }}
                </td>
                <td class="px-6 py-3" v-for="s in item.schedules">
                    <span class=" whitespace-nowrap" v-if="s.desk">
                        {{ s.desk.name }}
                        <i class="whitespace non-wrap fa" :class="{
                            'fa-check-circle text-green-500': s.checked_in_at != null,
                            'fa-times-circle text-red-400': s.checked_in_at === null,
                        }"></i>
                    </span>
                    <span v-if="!s.desk && !getPresence(item.id, s.day)">
                        ausstehend
                    </span>
                    <span v-if="!s.desk && getPresence(item.id, s.day)">
                        {{ translate(getPresence(item.id, s.day)) }}
                    </span>
                </td>
            </tr>
        </tailwind-table>

        <div class="flex justify-center items-center">
            <i class="fa fa-check-circle text-green-500 mr-2"></i> = Eingechecked
            <i class="ml-4 fa fa-times-circle text-red-400 mr-2"></i> = Nicht eingechecked
        </div>

        <tailwind-table :header="['User']" class="mb-4" v-show="unregistered.length > 0">
            <template slot="header">
                Nicht registriere Nutzer
                <p v-show="unregistered.length === 0">Keine austehenden Einladungen gefunden.</p>
            </template>
            <tr v-for="(item, i) in unregistered"  :class="{'bg-gray-50': i % 2}">
                <td class="px-6 py-3">{{ item.email }}</td>
            </tr>
        </tailwind-table>

        <div v-if="group.id === 48">
            <full-card>
                <template slot="header">EG</template>
                <img src="/files/b2.png">
            </full-card>
            <full-card>
                <template slot="header">1. OG</template>
                <img src="/files/b1.png">
            </full-card>
            <full-card>
                <template slot="header">2. OG</template>
                <img src="/files/b2.png">
            </full-card>
        </div>


    </div>
</template>

<script>
import Headline from "../components/UI/Headline";
import Loading from "../components/UI/Loading";
import TailwindTable from "../components/UI/TailwindTable";
import SelectMenu from "../components/UI/SelectMenu";
import sortBy from "lodash/sortBy";
import CardFullInvisible from "../components/UI/CardFullInvisible";
import Card from "../components/UI/Card";
import FullCard from "../components/UI/FullCard";
import ButtonLink from "../components/UI/ButtonLink";
import ButtonPrimary from "../components/UI/ButtonPrimary";
import InputText from "../components/UI/InputText.vue";
import UserGroups from "../components/UserGroups.vue";
import UserGroupFilter from "../components/Filter/UserGroupFilter.vue";
import ButtonSecondary from "../components/UI/ButtonSecondary"

export default {
    name: "UserAttendance",

    components: {
        UserGroupFilter,
        UserGroups,
        InputText,
        ButtonPrimary,
        ButtonLink,
        FullCard,
        Card,
        CardFullInvisible,
        SelectMenu,
        TailwindTable,
        Loading,
        Headline,
        ButtonSecondary
    },

    inject: ['group'],

    data: () => ({
        userGroupFilter: '',
        search: '',

        loading: false,
        items: [],
        floors: [],
        presence: {},
        date: new Date(),
        days: [0, 1, 2, 3, 4, 5, 6],
        next: null,
        prev: null,
        unregistered: [],
        german: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
    }),

    created() {
        this.load();
    },

    computed: {
        header() {
            return ['User', 'Gruppe'].concat(this.datesText);
        },
        usersSorted() {
            let sorted = sortBy(this.items, ['name', 'first_name']);

            if (this.search.length > 0) {
                const search = this.search.toLowerCase();
                sorted = sorted.filter(item => {
                    return item.searchable.includes(search);
                });
            }

            if (this.userGroupFilter.length > 0) {
                sorted = sorted.filter(item => {
                    return item.user_groups.find(g => g.id === parseInt(this.userGroupFilter)) !== undefined;
                });
            }

            return sorted;
        },
        datesText() {
            return this.days.map(day => {
                //let date = addDays(this.date, day);
                const date = new Date(day);
                return `${this.german[date.getDay()]} ${date.getDate()}.${date.getMonth() + 1}`;
            })
        },
    },

    methods: {
        getPresence(user, day) {
            if (!this.presence[user]) {
                return null;
            }

            if (!this.presence[user][day]) {
                return null;
            }

            return this.presence[user][day];
        },
        translate(text) {
            if (text === 'holidays') {
                return 'Urlaub';
            }

            if (text === 'ill') {
                return 'Krank';
            }

            if (text === 'extern') {
                return 'Bei Mandant';
            }

            if (text === 'mobile') {
                return 'Mobile Work';
            }

            if (text === 'training') {
                return 'Schulung';
            }

            return text;
        },
        load(date = null) {
            this.loading = true;
            window.axios.get(`/admin/user_attendances`, {
                params: {
                    date: date,
                }
            }).then(result => {
                this.items = result.data.data.map(item => {
                    item.searchable = `${item.first_name} ${item.name} ${item.user_groups.map(g => g.name).join(' ')}`.toLowerCase();
                    return item;
                });
                this.presence = result.data.presence;
                this.unregistered = result.data.unregistered;
                this.floors = result.data.floors;
                this.date = new Date(result.data.start_day);
                this.days = result.data.days;
                this.next = result.data.next;
                this.prev = result.data.prev;
                this.loading = false;
            }).catch(error => {
                this.loading = false;
                this.$root.$emit('error', error);
            })
        }
    }
}
</script>

<style scoped>

</style>
